export default __webpack_public_path__ + "static/media/Group9239.f3b0d4f5.svg";